import styled from "styled-components";
import { backgroundColor, primaryColor, tertiaryColor } from "../../styles/variables";

const HeaderContainer = styled.header`
color: ${primaryColor};
background-color: ${tertiaryColor};
width: 100vw;
height: 50vh;
display: flex;
flex-direction: column;
justify-content: space-around;
align-items: center;

img {
    max-width: 20vw;
    border-radius: 50%;
}
h1 {
    font-size: 2rem;
    &:hover{
        cursor: pointer;
        transition: .5s;
        color: ${backgroundColor};
    }
}
ul {
    display: flex;
    li, a {
        margin: 1rem;
        color: ${primaryColor};
        text-decoration: none;
        &:hover{
        cursor: pointer;
        transition: .5s;
        color: ${backgroundColor};
    }
    }
}
a {
    text-decoration: none!important; 
    color: black!important;

}
.profile-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 20vw;
    max-height: 20vh;
    text-align: center;
    img {
        width: 40%;
        height: 80%;
        margin: 10%;
    }
    button {
        margin-top: 10%;
        border-radius: 30%;
        color: white;
        background-color: ${backgroundColor};
        padding: 5px;
        font-size: 1rem;
    }
}

@media only screen and (min-width: 600px){
        flex-direction: column;
        height: 50vh;
        img {
            width: 25vw;
        }
        .profile-header {
            img {
                width: 60%;
                height: 80%;
                margin: 10%;
    }
        }
    }
@media only screen and (min-width: 900px){
        flex-direction: row;
        height: 50vh;
        img {
            width: 15vw;
        }
        .profile-header {
            img {
                width: 15vw;
                height: 10vh;
                margin: 10%;
            }
        }
    }
    @media only screen and (min-width: 1300px){
        flex-direction: row;
        height: 50vh; 
        img {
            width: 20vw;
        }
        .profile-header {
            img {
                width: 7vw;
                height: 10vh;
                margin: 10%;
            }
        }
    } 
`;

export { HeaderContainer }